import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';

import {Dibujo} from '../../../../../chacra-core';

export {Dibujo} from '../../../../../chacra-core';

export const dibujosAdapter: EntityAdapter<Dibujo> = createEntityAdapter<Dibujo>({
  selectId: model => model.dibujoId,
  sortComparer: (a: Dibujo, b: Dibujo): number =>
    b.dibujoId.toString().localeCompare(a.dibujoId.toString())
});

export interface DibujosState extends EntityState<Dibujo> {
  isLoading?: boolean;
  error?: string | null;
}

export const initialState: DibujosState = dibujosAdapter.getInitialState(
  {
    isLoading: false,
    error: null
  }
);
